import { ONBOARD_COMPANY, COMPANY_ONBOARD_SUCCESS, COMPANY_ONBOARD_FAILURE, GET_SUBSCRIPTIONS, GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS_FAILURE, CREATE_SUBSCRIPTION_SESSION, CREATE_SUBSCRIPTION_SESSION_SUCCESS, CREATE_SUBSCRIPTION_SESSION_FAILURE } from "../constants";

export default class SubscriptionsAction {
    static GetSubscriptions(cb) {
        return {
            type: GET_SUBSCRIPTIONS,
            cb
        }
    }

    static GetSubscriptionsSuccess(payload) {
        return {
            type: GET_SUBSCRIPTIONS_SUCCESS,
            payload
        }
    }

    static GetSubscriptionsFailure() {
        return {
            type: GET_SUBSCRIPTIONS_FAILURE,
        }
    }

    static CreateSubscriptionSession(payload) {
        return {
            type: CREATE_SUBSCRIPTION_SESSION,
            payload
        }
    }
}